<template>
  <PSelectKeyValue
      :options="countries"
      :value="value"
      label="label"
      track-by="value"
      :multiple="true"
      allow-empty
      :placeholder="$pgettext('core.label','Select Countries')"
      @update:value="onInput"
  />
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PSelectKeyValue from "@/domain/core/components/PSelectKeyValue.vue";

export default {
  name: "CountrySelect",
  components: {PSelectKeyValue},
  data() {
    return {
      loading: true,
    }
  },
  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emits: ['input'],
  async mounted() {
    await this.fetchCountries()
    this.loading = false
  },

  computed: {
    ...mapGetters('core', [
      'countries'
    ]),
  },

  methods: {
    ...mapActions('core', [
      'fetchCountries',
    ]),
    onInput(val) {
      this.$emit('input', val)
    }
  },

}
</script>
